import { Auth } from 'firebase/auth';
import { CREDENTIALS_KEY } from './login-with-popup.interactor';

export class LogoutInteractor {
  constructor(
    private readonly auth: Auth,
    private readonly storage: Storage,
  ) {}

  public async execute(): Promise<void> {
    await this.auth.signOut();

    // Clear storage credentials
    this.storage.removeItem(CREDENTIALS_KEY);
  }
}
